import axios from "axios";
import { reqSuccess, reqError, resSuccess, resError } from "./interceptors";
const service = axios.create({
  baseURL: "/api", // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 30000, // request timeout
});
service.defaults.headers.common["Content-Type"] = "application/json";
service.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
service.interceptors.request.use(reqSuccess, reqError);
service.interceptors.response.use(resSuccess, resError);

// {
//   responseType: 'document'
// }

const http = {
  getBlob(url) {
    return new Promise((resolve, reject) => {
      service({
        method: "get",
        url,
        responseType: "blob",
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  },
  postBlob(url, optins) {
    return new Promise((resolve, reject) => {
      service({
        method: "post",
        url,
        responseType: "blob",
        data: optins,
      })
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  },
  get(url, params, options = null) {
    return new Promise((resolve, reject) => {
      service
        .get(url, { params }, options)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  },
  post(url, params, options = null) {
    return new Promise((resolve, reject) => {
      service
        .post(url, params, options)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  },
  put(url, params, options = null) {
    return new Promise((resolve, reject) => {
      service
        .put(url, params, options)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  },
  delete(url, params, options = null) {
    return new Promise((resolve, reject) => {
      service
        .delete(url, params, options)
        .then((res) => {
          resolve(res.data);
        })
        .catch((err) => {
          reject(err.data);
        });
    });
  },
};
export default http;
